import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const LocationEffect = ({ onLocationChange })=>{
    const location = useLocation();
    useEffect(()=>{
        onLocationChange(location);
    }, [
        location,
        onLocationChange
    ]);
    return null; // component is just for Effect, not render
};
export default LocationEffect;
